export enum TrainingPersonType {
  Guest = 0,
  Employee = 1,
}
